module.exports = __webpack_public_path__ + "img/logo-bashou.c3889990.png";